import module from 'guest/module.js'
import template from './template.html'

class GuestBalanceComponent {
  constructor () {
    this.idMoneda = null
    this.balance = null
    this.monedas = null
  }

  $onInit () {
    this.filtrar()
  }

  filtrar () {
    this.data = this.balance.filter((item) => item.Moneda === this.idMoneda)
  }
}

module.component('guestBalance', {
  controller: GuestBalanceComponent,
  template,
  bindings: {
    idMoneda: '<',
    balance: '<',
    monedas: '<',
  },
})



// WEBPACK FOOTER //
// ./src/guest/components/balance/component.js